import i18next from 'i18next';

import {
  toggleClosePositionConfirmationModal,
  toggleConfirmationPopup,
} from 'actions/placeorder';
import Modal from 'components/modal';
import { mergeDeepRight } from 'helpers/ramda';
import useCustomMediaQuery from 'hooks/useMediaQuery';
import {
  closePositionConfirmationModalIsOpenSelector,
  showConfirmationPopupSelector,
} from 'selectors/placeOrderSelector';
import { useAppDispatch, useAppSelector } from 'storeHooks';

import ClosePositionConfirmation from './ClosePositionConfirmation';
import ConfirmationComponent from './ConfirmationComponent';
import modalStyleOverrides from './ModalStyles';

const contentLabel = i18next.t('trading:closePosition');

/**
 * to be used when placing an order returns ClosePositionInsufficientMargin error
 * @returns Modal
 */
const Modals = () => {
  const dispatch = useAppDispatch();
  const confirmationModalIsOpen = useAppSelector(
    closePositionConfirmationModalIsOpenSelector
  );
  const confirmationModalContent = useAppSelector(showConfirmationPopupSelector);

  const handleModalClose = () => {
    dispatch(toggleClosePositionConfirmationModal(!confirmationModalIsOpen));
  };

  const handleConfirmationModalClose = () => {
    dispatch(toggleConfirmationPopup(false));
  };

  const { isMobile } = useCustomMediaQuery();

  const responsiveStyles = {
    content: {
      transform: isMobile ? 'translate(-50%)' : 'translate(-50%,-40vh)',
      top: isMobile ? 'unset' : '45%',
      right: isMobile ? 'unset' : 'auto',
    },
  };

  return (
    <>
      <Modal
        isOpen={confirmationModalContent}
        style={mergeDeepRight(modalStyleOverrides, responsiveStyles)}
        contentLabel={contentLabel}
        onRequestClose={handleConfirmationModalClose}
      >
        <ConfirmationComponent />
      </Modal>
      <Modal
        isOpen={confirmationModalIsOpen}
        onRequestClose={handleModalClose}
        content=""
      >
        <ClosePositionConfirmation handleModalClose={handleModalClose} />
      </Modal>
    </>
  );
};

export default Modals;
